// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqQuoteDetailsInformationStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import OrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import { css } from "styled-components";

rfqQuoteDetailsInformationStyles.detailsGridContainer = {
    ...OrderInformationStyles.headingAndTextStyles?.wrapper,
};

rfqQuoteDetailsInformationStyles.expirationDateLabelText = {
    ...OrderInformationStyles.headingAndTextStyles?.heading,
};

rfqQuoteDetailsInformationStyles.jobNameHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};

rfqQuoteDetailsInformationStyles.salesRepHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};

rfqQuoteDetailsInformationStyles.userHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};

rfqQuoteDetailsInformationStyles.statusHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};

rfqQuoteDetailsInformationStyles.dateLabelText = {
    ...OrderInformationStyles.headingAndTextStyles?.heading,
};

rfqQuoteDetailsInformationStyles.dateGridItem = {
    width: [12, 6, 4, 4, 4],
    css: css`
        > p {
            font-size: 12px;
            line-height: 18px;
        }
    `,
};

rfqQuoteDetailsInformationStyles.statusHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};

rfqQuoteDetailsInformationStyles.customerHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};

rfqQuoteDetailsInformationStyles.shipToHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};

rfqQuoteDetailsInformationStyles.notesHeadingAndText = {
    heading: {
        ...OrderInformationStyles.headingAndTextStyles?.heading,
    },
    text: {
        ...OrderInformationStyles.headingAndTextStyles?.text,
    },
};

rfqQuoteDetailsInformationStyles.customerGridItem = {
    width: [12, 6, 4, 4, 4],
};

rfqQuoteDetailsInformationStyles.shipToGridItem = {
    width: [12, 6, 4, 4, 4],
};

rfqQuoteDetailsInformationStyles.jobNameGridItem = {
    width: [12, 6, 4, 4, 4],
};

rfqQuoteDetailsInformationStyles.salesRepGridItem = {
    width: [12, 6, 4, 4, 4],
};

rfqQuoteDetailsInformationStyles.userGridItem = {
    width: [12, 6, 4, 4, 4],
};

rfqQuoteDetailsInformationStyles.statusGridItem = {
    width: [12, 6, 4, 4, 4],
};
